import React, { useState } from 'react'
import NavBar from './NavBar'
import NavBarTransparent from './NavBarTransparent'

function NavBars({ k, bgBlackTransparent }) {
    const [active, setactive] = useState(false)
    const [top, setTop] = useState(null)

    window.addEventListener("resize", () => {
        window.innerWidth > 786 && setactive(false)
    })

    window.addEventListener("scroll", (e) => {
        setTop(window.scrollY);
    })
    return (
        <React.Fragment>
            <NavBar
                active={active}
                setactive={setactive}
                top={top}
                k={k}
            />
            <NavBarTransparent
                active={active}
                setactive={setactive}
                k={k}
                bgBlackTransparent
            />
        </React.Fragment>
    )
}

export default NavBars